module.exports = __webpack_public_path__ + "img/icon-sale-report.8c66dd79.png";